const picture = (el, elToAnim) => {
  elToAnim.push({ node: el });
};

export default picture;
